import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const Group = styled.div`
  position: relative;
  @media ${mq(sizes.desktop)} {
    display: flex;
    flex-flow: row nowrap;
  }
`

export const FirstCard = styled.div`
  & > .content-card {
    border-radius: 2rem 2rem 0 0;
  }

  @media ${mq(sizes.desktop)} {
    width: 50%;
    & > .content-card {
      border-radius: 2rem 0 0 2rem;
    }
  }
`

export const SecondCard = styled.div`
  & > .content-card {
    border-radius: 0 0 2rem 2rem;

    .texture-section {
      &::before {
        content: '';
        width: 80%;
        height: 0.1rem;
        background: white;
      }
    }
  }

  @media ${mq(sizes.desktop)} {
    width: 50%;
    & > .content-card {
      border-radius: 0 2rem 2rem 0;

      .texture-section {
        &::before {
          content: '';
          width: 0.1rem;
          height: 80%;
          background: white;
        }
      }
    }
  }
`

export const PlusCircle = styled.div<{ backgroundColor?: string }>`
  background: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.colors.redMandy};
  position: absolute;
  border-radius: 50%;
  height: 3.8rem;
  width: 3.8rem;
  left: calc(50% - 1.9rem);
  top: calc(50% - 1.9rem);
  padding: 0.8rem;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  color: ${({ theme }) => theme.colors.pureWhite};

  @media ${mq(sizes.desktop)} {
    height: 6.6rem;
    width: 6.6rem;
    left: calc(50% - 3.3rem);
    top: calc(50% - 3.3rem);
    padding: 1.5rem;
  }
`
